// extracted by mini-css-extract-plugin
export default {"text":"Footer_text__27sON"};